import { makeMenuIcon } from '@/lib/menuIcons'
import type { SidebarTab } from '@shared/ui/layout'

export function getItServiceCategoryOrder(locale: string): string[] {
  return locale === 'en' ? ['Workspace', 'Requests'] : ['워크스페이스', '요청·장애']
}

export function getItServiceTabs(locale: string): SidebarTab[] {
  const en = locale === 'en'
  const workspace = en ? 'Workspace' : '워크스페이스'
  const requests = en ? 'Requests' : '요청·장애'
  return [
    {
      id: 'index',
      label: en ? 'Dashboard' : '대시보드',
      icon: makeMenuIcon('itsm-dashboard'),
      href: '/it-service',
      labelType: [workspace],
    },
    {
      id: 'my-tickets',
      label: en ? 'My tickets' : '내 티켓',
      icon: makeMenuIcon('itsm-tickets'),
      href: '/it-service/my-tickets',
      labelType: [workspace],
    },
    {
      id: 'servicerequests',
      label: en ? 'Service requests' : '서비스 요청',
      icon: makeMenuIcon('itsm-requests'),
      href: '/it-service/servicerequests',
      labelType: [requests],
    },
    {
      id: 'incidents',
      label: en ? 'Incidents' : '장애 관리',
      icon: makeMenuIcon('itsm-incidents'),
      href: '/it-service/incidents',
      labelType: [requests],
    },
    {
      id: 'changerequests',
      label: en ? 'Change management' : '변경 관리',
      icon: makeMenuIcon('itsm-changes'),
      href: '/it-service/changerequests',
      labelType: [requests],
    },
  ]
}

/** @deprecated use getItServiceTabs */
export const itServiceTabs: SidebarTab[] = getItServiceTabs('ko')
